module.exports = __webpack_public_path__ + "static/studies-628986454.4e44948f.jpg";